import { render, staticRenderFns } from "./ExamQC.vue?vue&type=template&id=508e90e9&scoped=true&"
import script from "./ExamQC.vue?vue&type=script&lang=js&"
export * from "./ExamQC.vue?vue&type=script&lang=js&"
import style0 from "./ExamQC.vue?vue&type=style&index=0&id=508e90e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508e90e9",
  null
  
)

export default component.exports